<template>
    <v-dialog v-model="show" max-width="450px">
        <v-card>
            <v-card-title>Select Unit<v-spacer></v-spacer>
                <v-btn text small @click.stop="show=false"><i class="fa fa-times" aria-hidden="true"></i></v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-col cols="6">
                        <label for="">Base Unit</label>
                        <v-select class="mt-2" outlined dense label="" 
                            v-model="base_unit" :items="this.units" @change="selectBaseUnit">
                        </v-select>
                    </v-col>
                    <v-col cols="6">
                        <label for="" class="my-2">Secondary Unit</label>
                        <v-select class="mt-2" outlined dense label="" 
                            v-model="secondary_unit" :items="this.units" @change="selectSecondaryUnit">
                        </v-select>
                    </v-col>
                    <v-col cols="12" style="margin-top:-30px !important" v-if="showConversionRate">
                        <h4>Conversion Rate -</h4>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-end px-0 mx-0" v-if="showConversionRate">
                        <v-subheader> 1 {{ base_unit }} =</v-subheader>
                    </v-col>
                    <v-col cols="3" class="px-0 mx-0 my-1" v-if="showConversionRate">
                        <v-text-field label="" v-model="secondary_unit_value" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-start px-0 mx-0" v-if="showConversionRate">
                        <v-subheader> {{ secondary_unit }} </v-subheader>
                    </v-col>
                    <v-col cols="12" v-if="showError">
                        <span style="color:red">Please Select Base Unit.</span>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider class="mt-12"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="submitUnit">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    // import { numeric } from 'vuelidate/lib/validators';


    export default {
        name: 'ProductPreview',
        components: {},
        props: ['value', 'units', 'baseUnit', 'secondaryUnit', 'secondaryValue'],
        data() {
            return {
                // base_unit: this.baseUnit,
                // secondary_unit: this.secondaryUnit,
                // secondary_unit_value: this.secondaryValue

                base_unit: null,
                secondary_unit: null ,
                secondary_unit_value:null,
                showConversionRate:false,
                showError:false,
            }
        },
        computed: {
            show: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            },
        },
        watch: {
            baseUnit(newVal) {
                this.base_unit = newVal
                // if( (this.base_unit!='None') && (this.secondary_unit!='None') ){
                //     this.showConversionRate = true
                // }

                if( (this.base_unit!='None') && (this.secondary_unit!='None') ){
                    this.showConversionRate = true
                }
                else if( (this.base_unit=='None') || (this.secondary_unit=='None') ){
                    this.showConversionRate = false
                }
                else {
                    this.showConversionRate = false
                }
                
            },
            secondaryUnit(newVal) {
                this.secondary_unit = newVal
                // if( (this.base_unit!='None') && (this.secondary_unit!='None') ){
                //     this.showConversionRate = true
                // 
                if( (this.base_unit!='None') && (this.secondary_unit!='None') ){
                    this.showConversionRate = true
                }
                else if( (this.base_unit=='None') || (this.secondary_unit=='None') ){
                    this.showConversionRate = false
                }
                else {
                    this.showConversionRate = false
                }

            },
            secondaryValue(newVal) {
                this.secondary_unit_value = newVal
            },
        },

        created() {
            // console.log("this.baseUnit", this.base_unit)

                this.base_unit =  this.baseUnit,
                this.secondary_unit = this.secondaryUnit,
                this.secondary_unit_value = this.secondaryValue

                if( (this.base_unit!='None') && (this.secondary_unit!='None') ){
                    this.showConversionRate = true
                }
                else if( (this.base_unit=='None') || (this.secondary_unit=='None') ){
                    this.showConversionRate = false
                }
                else {
                    this.showConversionRate = false
                }
        },
        mounted(){
            if( (this.base_unit!='None') && (this.secondary_unit!='None') ){
                    this.showConversionRate = true
                }
                else if( (this.base_unit=='None') || (this.secondary_unit=='None') ){
                    this.showConversionRate = false
                }
                else {
                    this.showConversionRate = false
                }
        },
        methods: {
            submitUnit() {
                if( (this.base_unit!='None') ){
                    this.$emit("passUnits", {
                        base_unit: this.base_unit,
                        secondary_unit: this.secondary_unit,
                        secondary_unit_value: this.secondary_unit_value
                    });
                    this.show = false
                    this.showError = false
                }
                else {
                    this.showError = true
                }
              
            },
            selectBaseUnit(){
                if( (this.base_unit!='None') && (this.secondary_unit!='None') ){
                    this.showConversionRate = true
                }
                else if( (this.base_unit=='None') || (this.secondary_unit=='None') ){
                    this.showConversionRate = false
                }
                else {
                    this.showConversionRate = false
                }
            },
            selectSecondaryUnit(){
                if( (this.base_unit!='None') && (this.secondary_unit!='None') ){
                    this.showConversionRate = true
                }
                else if( (this.base_unit=='None') || (this.secondary_unit=='None') ){
                    this.showConversionRate = false
                }
                else {
                    this.showConversionRate = false
                }
            }
        }
    }
</script>